import { render, staticRenderFns } from "./mitra-space.vue?vue&type=template&id=1378aabc&scoped=true"
import script from "./mitra-space.vue?vue&type=script&lang=js"
export * from "./mitra-space.vue?vue&type=script&lang=js"
import style0 from "./mitra-space.vue?vue&type=style&index=0&id=1378aabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378aabc",
  null
  
)

export default component.exports